<div #container *ngIf="template" class="drag-indicator planning-item border {{ groupClass ?? itemClass }}" [style.width.px]="width">
  <div #newGroupHeader class="font-weight-semibold new-group-header">
    <p class="font-weight-semibold header-text">{{ newGroupText }}</p>
  </div>
  <div class="full-height planning-item {{ itemClass }}">
    <ng-container *ngTemplateOutlet="template; context: templateContext"></ng-container>
  </div>
</div>
